import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");

// react-snap prerenders each route to static HTML during `yarn build`. When
// the browser loads that HTML we hydrate on top instead of re-rendering, so
// the SEO content stays visible during the JS boot and search bots that
// disable JS still see the full page. When there's no prerendered content
// (dev server), we fall back to a normal render.
const hasPrerender = rootEl && rootEl.hasChildNodes();
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

if (hasPrerender) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
